module.exports = __webpack_public_path__ + "static/media/portal-summary-phone_graphic.9ba0ed64.png";